import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
import {Methods} from "@newview/infrastructure";


export class MaterialcategoryApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialcategory'
  }


  /**
   * 数据导入
   * @param data
   */
  public importData(data){
    return this.send(data,"importData",Methods.POST)
  }

}